import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { PhoneIcon, MailIcon } from 'assets/svgs/';
import { Link } from 'gatsby';

const GetInTouch = React.forwardRef((props, ref) => (
  <Container {...props} ref={ref}>
    <p>Get in touch with us for a free consultation</p>
    <a href="tel:+35314507826" target="_blank" rel="noreferrer">
      <PhoneIcon />
      <span>+353 1 450 7826</span>
    </a>
    <Link to="/contact-us/">
      <MailIcon />
      <span>Email Us</span>
    </Link>
  </Container>
));

const Container = styled(motion.div).attrs({
  initial: {
    y: -30
  },
  animate: {
    y: 0
  },
  transition: {
    delay: 0.75
  }
})`
  align-items: center;
  background-color: var(--connolly-black);
  border-bottom-left-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
  color: #fff;
  display: flex;
  height: 1.875rem;
  justify-content: space-evenly;
  margin: 0 auto;
  max-width: 16.125rem;
  width: 100%;

  @media (width >= 768px) {
    max-width: 32rem;
    padding-left: 1rem;
  }

  p {
    color: #fff;
    font-size: 0.75rem;
    margin-right: 1rem;
    margin-bottom: 2px;

    @media (width <= 767px) {
      display: none;
    }
  }

  a {
    color: #fff;
    display: flex;
    font-size: 0.75rem;
    justify-content: center;

    span {
      color: #fff;
      margin: 0 0 0 0.375rem;

      @media (width >= 768px) {
        margin: 0 0.75rem 0 0.375rem;
      }
    }

    svg {
      width: 1.25rem;
    }
  }
`;

export default GetInTouch;
